"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _MessagesConstants = require("./MessagesConstants");

var _Utils = require("../../../util/Utils");

var _class, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @callback Messages~onRemoveMessage
 * @param {string} [containerId]
 *     The container id
 * @param {number|string} messageIndex
 *     Message index to remove
 */

/**
 * @callback Messages~onI18n
 * @param {string} key
 *     I18n message key
 * @param {object} [params]
 *     Params for i18n message
 * @returns {string}
 *     Result of i18n given message key
 */

/**
 * @typedef Messages~MessageItem
 * @memberof Messages
 * @property {node} text
 *     Message text
 * @property {Messages.MessageTypes} type
 *     Message type
 * @property {number} timer
 *     Number of milli seconds after which message should be removed
 * @property {number|string} index
 *     Message index.
 * @property {string} iconName
 *     When provided, show this icon on the left of the message
 * @property {boolean} hideClose
 *     When true, we don't display the close button
 * @property {Messages.Layouts} [layout=BANNER]
 *     When set to CORNER, displays the message in the top right corner
 * @property {boolean} isHtml
 *     DEPRECATED: no longer needed. You can now simply use html in your messages as needed.
 * @property {Messages~ProgressSpec}
 *     Object containing data to show a progress bar in the message.
 * @property {boolean} minimized
 *     When true, the message is shown in a minimized form, which hides
 *     everything but the progress.
 */

/**
 * @typedef Messages~ProgressSpec
 * @property {string} text
 *      If set, provides the text for the message next to the progress bar.
 * @property {function} textTemplate
 *      If text isn't set and this is, this function accepts a single argument
 *      of the current progress percentage and returns the text that should be
 *      shown next to the progress bar.
 * @property {number} percent
 *      The current value 0-100 of the progress bar.
 */

/**
 * @class Messages
 * @desc Messages component. Renders a list of supplied message strings and allows for messages
 * to be removed by invoking a callback.
 *
 * @param {string} [data-id="messages"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {Messages.ContainerTypes} [containerType]
 *     Enum which specifies the container type. Do not set for messages that should only fill the content area to the
 *     right of a left-nav. FULL takes the width of the entire window. MODAL is used for Messages within modals.
 *
 * @param {Messages~MessageItem[]} [messages]
 *     List of messages to render.
 * @param {Messages~onRemoveMessage} [onRemoveMessage]
 *     Callback to be triggered when a message is removed.
 * @param {Messages~onI18n} [onI18n]
 *     Callback to be triggered for internationalization of message keys to message text.
 * @param {number} [defaultMessageTimeout]
 *     Default message timeout in ms. Messages will remove themselves after this time, unless the message specifically
 *     overrides the default timeout itself.
 * @param {Messages.Layouts} [defaultMessageLayout=CORNER]
 *     Default message layout for this messages component. Messages that don't set their own layout type will receive this on.
 *
 * @example
 * Usage:
 *     <Messages messages={messages}
 *      data-id="page-messages"
 *      onRemoveMessage={this._handleRemoveMessage} />
 *
 * @see {@link module:MessagesActions} for documentation on interacting with the Messages reducer.
 */
module.exports = (_temp = _class = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(_class, _React$Component);

  var _super = _createSuper(_class);

  function _class() {
    (0, _classCallCheck2.default)(this, _class);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(_class, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          containerType = _this$props.containerType,
          dataId = _this$props["data-id"],
          defaultMessageTimeout = _this$props.defaultMessageTimeout,
          defaultMessageLayout = _this$props.defaultMessageLayout,
          key = _this$props.key,
          messages = _this$props.messages,
          onI18n = _this$props.onI18n,
          onRemoveMessage = _this$props.onRemoveMessage;
      var className = (0, _classnames.default)("page-messages", containerType);
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": dataId,
        className: className
      }, messages && (0, _map.default)(messages).call(messages, function (item, i) {
        var _context;

        return /*#__PURE__*/_react.default.createElement(Message, {
          key: key || i,
          index: i,
          message: item,
          onI18n: onI18n,
          onRemoveMessage: onRemoveMessage,
          defaultTimeout: defaultMessageTimeout,
          defaultLayout: defaultMessageLayout,
          "data-id": (0, _concat.default)(_context = "".concat(dataId, "-message-")).call(_context, i)
        });
      }));
    }
  }]);
  return _class;
}(_react.default.Component), (0, _defineProperty2.default)(_class, "displayName", "Messages"), (0, _defineProperty2.default)(_class, "propTypes", {
  "data-id": _propTypes.default.string,
  containerType: _propTypes.default.oneOf(["full", "page-messages--sidebar-fix"]),
  messages: _propTypes.default.array,
  onRemoveMessage: _propTypes.default.func,
  removeMessage: _propTypes.default.func,
  onI18n: _propTypes.default.func,
  i18n: _propTypes.default.func,
  defaultMessageTimeout: _propTypes.default.number,
  defaultMessageLayout: _propTypes.default.oneOf((0, _values.default)(_MessagesConstants.Layouts))
}), (0, _defineProperty2.default)(_class, "defaultProps", {
  "data-id": "messages",
  onRemoveMessage: null,
  onI18n: function onI18n(key) {
    return key;
  },
  defaultMessageLayout: _MessagesConstants.Layouts.CORNER
}), _temp);
/*
 * @class Message
 * @desc Message sub-component to render an individual message and handle its closing (and removal from the store).
 *
 */

var Message = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(Message, _React$Component2);

  var _super2 = _createSuper(Message);

  function Message() {
    var _context2;

    var _this;

    (0, _classCallCheck2.default)(this, Message);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, (0, _concat.default)(_context2 = [this]).call(_context2, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleRemove", function () {
      _this.props.onRemoveMessage(_this.props.index);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderProgress", function () {
      var progress = _this.props.message.progress;
      var percent = progress.percent || 50;
      var text = progress.text || progress.textTemplate && progress.textTemplate(percent) || "".concat(progress.percent, "%");
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "message__progress",
        "data-id": _this.props["data-id"] + "-progress"
      }, percent >= 100 && /*#__PURE__*/_react.default.createElement("div", {
        className: "message__progress-icon icon-check"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "message__progress-text",
        "data-id": _this.props["data-id"] + "-progress-text"
      }, text), percent < 100 && /*#__PURE__*/_react.default.createElement("div", {
        className: "message__progress-border"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "message__progress-bar",
        style: {
          width: "".concat(percent, "%")
        }
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_iconName", {
      "success": "check",
      "warning": "error-triangle",
      "error": "alert",
      "info": "info"
    });
    return _this;
  }

  (0, _createClass2.default)(Message, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.dispatchEvent((0, _Utils.createCustomEvent)("ui-library-message", this.displayName)); // Close after configured time interval
      // Interval of 0 (or undefined) will result in no automatic message clearing (which is intended).

      var interval = this.props.message.duration ? this.props.message.duration : this.props.defaultTimeout;

      if (interval) {
        this.interval = global.setInterval(this._handleRemove, interval);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.interval) {
        // clear the timer before unmounting the component
        global.clearInterval(this.interval);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          defaultLayout = _this$props2.defaultLayout,
          _this$props2$message = _this$props2.message,
          type = _this$props2$message.type,
          _this$props2$message$ = _this$props2$message.iconName,
          iconName = _this$props2$message$ === void 0 ? this._iconName[type] : _this$props2$message$,
          key = _this$props2$message.key,
          hideClose = _this$props2$message.hideClose,
          _this$props2$message$2 = _this$props2$message.layout,
          layout = _this$props2$message$2 === void 0 ? defaultLayout : _this$props2$message$2,
          minimized = _this$props2$message.minimized,
          params = _this$props2$message.params,
          progress = _this$props2$message.progress,
          message = (0, _objectWithoutProperties2.default)(_this$props2$message, ["type", "iconName", "key", "hideClose", "layout", "minimized", "params", "progress"]);
      var text = message.text || this.props.onI18n(key, params);
      var classes = (0, _classnames.default)("message show", type, {
        "message--minimized": minimized,
        "message--corner": layout === _MessagesConstants.Layouts.CORNER,
        "message--center": layout === _MessagesConstants.Layouts.CENTER
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes,
        "data-id": this.props["data-id"]
      }, iconName && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("message__icon", "icon-".concat(iconName))
      }), !minimized && text && /*#__PURE__*/_react.default.createElement("span", {
        className: "message__text"
      }, text), progress && this._renderProgress(), !hideClose && /*#__PURE__*/_react.default.createElement("a", {
        className: "close",
        onClick: this._handleRemove,
        "data-id": "message-close"
      }));
    }
  }]);
  return Message;
}(_react.default.Component);

(0, _defineProperty2.default)(Message, "propTypes", {
  onRemoveMessage: _propTypes.default.func,
  iconName: _propTypes.default.string,
  defaultMessageLayout: _propTypes.default.oneOf((0, _values.default)(_MessagesConstants.Layouts))
});
(0, _defineProperty2.default)(Message, "defaultProps", {
  onRemoveMessage: _underscore.default.noop
});